import {useDrawer} from "../../providers/drawer-manager.provider";
import {DrawerComponent} from "../drawer/drawer.component";
import React, {Suspense} from "react";
import {serviceStore} from "../../storeAndServices/service.store";
import {ServiceLoadingComponent} from "../loading/serviceLoading.component";

export const DrawerManagerComponent = () => {
    const {serviceQueue, completeService, activeService, open, onOpenChange} = useDrawer();
    const definition = serviceStore[activeService || ""]

    return (
        <>
            <DrawerComponent
                backBtnDisplay
                $fitScreenOnSmall={true}
                $side="right"
                showCloseButton
                onClose={completeService}
                closeOnOutside
                header={definition ? definition.title : "Service not found!"}
                open={open}
                onOpenChange={onOpenChange}
                $backdrop
                $size={"lg"}
                overlay
            >
                <Suspense fallback={<ServiceLoadingComponent />}>
                    {(activeService && definition) && <definition.component/>}
                </Suspense>
            </DrawerComponent>
        </>
    )
}